import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      dark: '#020c1b',
      main: '#0a192f',
      light: '#112240',
      lighter: '#233554',
    },

    secondary: {
      main: '#64ffda',
      tint: 'rgba(100,255,218,0.1)',
      darkTint: 'rgba(100,255,218,0.75)',
    },

    slate: {
      dark: '#495670',
      main: '#8892b0',
      light: '#a8b2d1',
      lighter: '#ccd6f6',
      lightest: '#e6f1ff',
    },
  },

  typography: {
    allVariants: {
      color: '#8892b0',
      fontFamily: `'Noto Sans', sans-serif`,
    },

    h1: {
      fontSize: '4.5rem',
      fontWeight: 500,
    },
  },

  borderRadius: {
    small: '3px',
  },
});

export default theme;
